export enum AnnouncementRecipients {
  EVERYONE = -1
}

export enum AnnouncementTabEnum {
  ALL= 'All',
  PROGRAMS = 'Programs',
  GRADES = 'Grades'
}
